<template>
  <svg
    v-if="image"
    :viewBox="image.viewBox"
    role="img"
    v-on="$listeners"
  >
    <use v-bind="{ 'xlink:href': image.url }" />
  </svg>
</template>

<script>
export default {
  name: 'AjIcon',

  props: {
    shape: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      image: null,
    };
  },

  watch: {
    shape () {
      this.setImageHandler();
    },
  },

  created () {
    this.setImageHandler();
  },

  methods: {
    async setImage () {
      if (!this.shape) {
        return false;
      }
      const imageModule = await this.importShape();
      if (imageModule?.default) {
        this.image = imageModule.default;

        return true;
      }

      return false;
    },

    async importShape () {
      const response = await import(`@/sprite/${this.shape}.svg`);

      return response;
    },

    setImageHandler () {
      try {
        this.setImage();
      } catch (error) {
        this.image = { viewBoxCoord: '0 0 0 0', id: '#none' };
        throw new Error(`No SVG present for shape: ${this.shape}`);
      }
    },
  },
};
</script>
